import Layout from "../../components/Layout/Layout";
import ProductCard from "../../components/ProductCard/ProductCard";

import "./Favourites.css";
import { useFavouritesData } from "../../hooks/api/useFavouritesData";
import { useFavourites } from "../../hooks/logic/useFavourites";
import { useProductsByIds } from "../../hooks/api/useProductsByIds";

const Favourites = () => {
  const { handleFav, favProductsIds } = useFavourites();
  const { data: pageData } = useFavouritesData();
  const { data } = useProductsByIds(favProductsIds);

  if (!pageData) return null;

  return (
    <Layout withFooter={false}>
      <div className="container favourite-container">
        {data.length ? (
          <div className="favourites">
            {data.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                showTrash
                onTrashClick={() => handleFav(String(product.id))}
              />
            ))}
          </div>
        ) : (
          <div className="favourites__empty">
            <svg width="56" height="56" fill="none" viewBox="0 0 24 24">
              <path
                d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"
                stroke="#d0d0d0" strokeWidth="1.5" strokeLinejoin="round"
              />
            </svg>
            <p className="favourites__empty-title">
              {pageData.attributes.emptyFavText}
            </p>
            <p className="favourites__empty-subtitle">
              Додайте товари, які вамподобаються
            </p>
            <a href="/" className="favourites__empty-btn">
              Переглянути товари
            </a>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Favourites;
